import {ConfigurationEconde} from "../configurations";
import CryptoJS from "crypto-js";

export const CryptoJSHelper = {
    encrypt: (encoder: ConfigurationEconde, userString: string) : string =>
        CryptoJS.AES.encrypt(userString, CryptoJS.enc.Utf8.parse(encoder.key.substring(0, encoder.keyLength)), {
            iv: CryptoJS.enc.Utf8.parse(encoder.iv.substring(0, encoder.ivLength)),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }).toString(),
    
    decrypt: (encoder: ConfigurationEconde, userEncrypt: string) : string =>
        CryptoJS.AES.decrypt(userEncrypt, CryptoJS.enc.Utf8.parse(encoder.key.substring(0, encoder.keyLength)), {
            iv: CryptoJS.enc.Utf8.parse(encoder.iv.substring(0, encoder.ivLength)),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }).toString(CryptoJS.enc.Utf8),
}

